import { useMemo } from 'react';
import appRoutes from '~/appRoutes';
import { type DashboardTab, useDashboardTabs } from '~/hooks/useDashboardTabs';
import { useFormatMessage } from '~/intl';

export function usePortfolioTabs() {
  const formatMessage = useFormatMessage();

  const tabs = useMemo<DashboardTab[]>(
    () => [
      {
        icon: 'BarChartIcon',
        id: 'position-monitoring',
        label: formatMessage({ id: 'navigation.positionMonitoring' }),
        route: appRoutes.POSITION_MONITORING,
      },
      {
        icon: 'TableLineIcon',
        id: 'custom-views',
        isDynamicRoute: true,
        label: formatMessage({ id: 'navigation.customTableViews' }),
        route: appRoutes.POSITION_MONITORING_CUSTOM_VIEWS(),
      },
      {
        icon: 'BarChartIcon',
        id: 'matching-analysis',
        label: formatMessage({ id: 'navigation.matchingAnalysis' }),
        route: appRoutes.MATCHING_ANALYSIS,
      },
    ],
    [formatMessage],
  );

  return useDashboardTabs(tabs, {
    disabledTabValues: ['position-monitoring-table'],
    storageDefaultValue: 'position-monitoring',
    storageKey: 'portfolio-view.tab',
  });
}
